import styled from 'styled-components';

const NRICWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 1.25rem 1.25rem 2.5rem 1.25rem;
`;

export default NRICWrap;